import * as React from 'react';
import { FrontLayout } from 'client/ui/layout/FrontLayout';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Row, Col, Typography, Space, Card } from 'antd';
const { Title, Text, Paragraph } = Typography;
import { LabeledDate } from 'client/ui/display/date/LabeledDate';
import { RequestStateTag } from 'client/components/schema/requests/status/RequestStateTag';
import { ISODate } from 'client/ui/display/date/ISODate';
import { RequestApi } from 'client/components/schema/requests/RequestApi';
import { AlertPage } from 'client/ui/alert/AlertPage';
import { getNetworkErrorMessage } from 'client/core/network/errors/getNetworkErrorMessage';
import { useApiQuery } from 'client/core/network/hooks/useApiQuery';
import { LoadingPage } from 'client/ui/loader/LoadingPage';
import { useBreadcrumbItem } from 'client/core/router/breadcrumb/BreadcrumbContext';
import { RequestDocumentDetailLink } from '../dossier/RequestDocumentDetailLink';
import { ProcedureSummaryTitle } from '../../procedures/single/shared/ProcedureSummaryTitle';
import { PageMainColumn } from 'client/ui/layout/page/PageMainColumn';
import { PageFullRow } from 'client/ui/layout/page/PageFullRow';
import { PageSecondaryColumn } from 'client/ui/layout/page/PageSecondaryColumn';
import { ProcedureLinkText } from 'client/ui/naming/ProcedureLinkText';
import { ProcedureLogic } from 'common/schema/ProcedureLogic';

interface Params {
  id: string;
}

export interface RequestSentPageProps extends RouteComponentProps<Params> {}

export function RequestSentPage(props: RequestSentPageProps) {
  const id = props.match.params.id ? parseInt(props.match.params.id, 10) : null;

  const { response, error, loading, refetch } = useApiQuery(RequestApi.find, {
    skip: id == null,
    data: {
      id: id!
    }
  });

  const request = response?.data;

  useBreadcrumbItem({ path: '/richieste', title: 'Le mie Istanze' });
  useBreadcrumbItem({ path: props.location.pathname, title: 'Dettagli' });

  if (error)
    return (
      <AlertPage
        showIcon
        type="error"
        message="Impossibile caricare la domanda"
        description={getNetworkErrorMessage(error)}
      />
    );

  if (!request || loading) return <LoadingPage />;

  return (
    <FrontLayout isUserPage>
      <PageFullRow>
        {/* Colonna Principale */}
        <PageMainColumn>
          <Card
            title="Dettaglio invio"
            extra={<Text type="secondary">{request.code}</Text>}
            actions={[<RequestDocumentDetailLink request={request} />]}
          >
            <Space direction="vertical" size={16}>
              <Paragraph className="request-sent-title">
                <Text type="secondary">Titolo Domanda:</Text>
                <Title level={3} style={{ marginTop: '0' }}>
                  {request.procedure.title}
                </Title>
              </Paragraph>
              <Paragraph>
                <Text type="secondary">Stato: </Text>
                <RequestStateTag status={request.state} />
              </Paragraph>
              <Paragraph>
                <Text type="secondary">Data Invio: </Text>
                <Text strong>
                  <ISODate date={request.sentAt} />
                </Text>
              </Paragraph>
              <Paragraph>
                <Text type="secondary">Codice Invio: </Text>
                <Text strong>{request.code}</Text>
              </Paragraph>
              {request.protocolSignature && (
                <Paragraph>
                  <Text type="secondary">Segnatura Protocollo: </Text>
                  <Text strong>{request.protocolSignature}</Text>
                </Paragraph>
              )}
            </Space>
          </Card>
        </PageMainColumn>

        {/* Colonna Sommario / Azioni */}
        <PageSecondaryColumn orderMobile={3}>
          <Space direction="vertical" size={16}>
            <ProcedureSummaryTitle children={request.procedure.title} />
            <LabeledDate
              label="Scadenza"
              date={ProcedureLogic.getRenderableDateWith24Hour(
                request.procedure.expiresAt
              )}
            />
            <Link to={`/domande/${request.procedure.id}`}>
              {ProcedureLinkText}
            </Link>
            {/* <Link to={''}>Vai alle Faq</Link> */}
          </Space>
        </PageSecondaryColumn>
      </PageFullRow>
    </FrontLayout>
  );
}
